module.exports = __webpack_public_path__ + "img/welcome-parchment-new.901924e0.webp";